<template>
  <div>
    <div v-if="pwdResetAuthenticated">
      <v-col offset-md="3" :md="6">
        <h1 class="primary--text text-center mt-5">User Profile</h1>
        <v-text-field type="password" v-model="newPwd"
          label="New Password"
        />
        <v-text-field type="password" v-model="rePwd"
          label="Re-type New Password"
        />
        <v-row>
          <v-btn color="error" outlined to="/">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="resetPwd">Reset Password</v-btn>
        </v-row>
      </v-col>
    </div>
    <div v-else>
      <h2 class="error--text text-center mt-4">Unknown Reset Password Code</h2>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'reset-pwd',
  props: [ 'pwdResetToken' ],
  data: () => ({
    pwdResetAuthenticated: false,
    newPwd: '',
    rePwd: '',
  }),
  created() {
    var tokData = {
      resetToken: this.pwdResetToken
    }
    const header = { 'Content-type': 'application/json' }
    const self = this
    axios.post('/api/authenticatePwdReset', JSON.stringify(tokData), { headers: header })
    .then(() => {
      self.pwdResetAuthenticated = true
    })
    .catch(err => {
      self.pwdResetAuthenticated = false
      alert(err.response.data.err)
    })
  },
  methods: {
    resetPwd() {
      if (this.newPwd == '') {
        return
      }
      if (this.newPwd != this.rePwd) {
        return alert('Password and Re-type Password are not identical')
      }
      var inData = {
        resetToken: this.pwdResetToken,
        newPassword: this.newPwd
      }
      const header = { 'Content-type': 'application/json' }
      const self = this
      axios.post('/api/updateResetPwd', JSON.stringify(inData), { headers: header })
      .then(() => {
        alert('Password has been reset.  Please login with the new password')
        self.$router.push('/')
      })
      .catch(err => {
        alert(err.response.data.err)
      })
    }
  }
}
</script>